module.exports = __webpack_public_path__ + "assets/img/patient-woman-icon.57328bd2.png";